import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Box,
  Typography,
} from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import { connect } from "react-redux";
import { getActions } from "../../store/actions/friendsActions";
const AddFriendDialog = ({
  isDialogOpen,
  closeDialogHandler,
  sendFriendInviations = () => {},
}) => {
  const [identifier, setIdentifier] = useState("");
  const [isFormValid, setIsFormValid] = useState("");
  const handlerSendInvitation = () => {
    // sendFriend Request to server
    sendFriendInviations(
      {
        targetIdentifier: identifier.trim(),
      },
      handleCloseDialog
    );
  };
  const handleCloseDialog = () => {
    closeDialogHandler();
    setIdentifier("");
  };
  useEffect(() => {
    setIsFormValid(identifier.trim().length >= 3);
  }, [identifier, setIsFormValid]);
  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCloseDialog}
      PaperProps={{
        sx: {
          bgcolor: "#282a30",
          color: "#f2f3f5",
          borderRadius: "8px",
          width: "440px",
          boxShadow: "0 16px 40px rgba(0,0,0,0.45)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>
          Добавить друга
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <DialogContentText component="div">
          <Typography sx={{ color: "#b5bac1", fontSize: "14px" }}>
            Введите username или e-mail пользователя, которому хотите отправить приглашение.
          </Typography>
          <InputWithLabel
            label="Username или e-mail"
            type="text"
            value={identifier}
            setValue={setIdentifier}
            placeholder="Например: alex или alex@mail.ru"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Box sx={{ display: "flex", width: "100%", gap: "12px" }}>
          <CustomPrimaryButton
            onClick={handleCloseDialog}
            label="Отмена"
            additionalStyles={{
              background: "#4e5058",
            }}
          />
        <CustomPrimaryButton
          onClick={handlerSendInvitation}
          disabled={!isFormValid}
          label="Отправить"
        />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
const mapActionsToProps = (dispatch) => {
  return {
    ...getActions(dispatch),
  };
};

export default connect(null, mapActionsToProps)(AddFriendDialog);
